// To get the encrypted data:
// <>
//          {Object.keys(pastUsers['cpf-cebu-province-marathon']).map((k) => (
//            <>
//              {`"${window.btoa(k)}": 1,`}
//              <br />
//            </>
//          ))}
//        </>

export const pastUsers = {
  // sample
  // 'event-slug': {
  //   // [encryptedEmail]: 1,
  // },
  // 'cpf-cebu-province-marathon': {
  //   'A@A.COM': 1,
  //   'B@B.COM': 1,
  //   BANJOCOM: 1,
  //   'JMATLUPIN7+USER4@GMAIL.COM': 1,
  // },

  // 'cpf-cebu-province-marathon': {
  //   'QUBBLkNPTQ==': 1,
  //   'QkBCLkNPTQ==': 1,
  //   'QkFOSk9DT00=': 1,
  //   'Sk1BVExVUElONytVU0VSNEBHTUFJTC5DT00=': 1,
  // },
  'cpf-cebu-province-marathon': {
    'RU5SSVRPSlJCQEdNQUlMLkNPTQ==': 1,
  },
}

export const checkRegisteredUser = (slug: string, email: string) => {
  if (!(slug in pastUsers)) return false

  const encrypted = window.btoa(email)
  const exists = pastUsers[slug][encrypted] || null

  return exists !== null
}
